import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3 rounded-xl border border-gray-lp-1600 bg-white px-3 py-3" }
const _hoisted_2 = { class: "flex items-center gap-2.5 border-b border-gray-lp-1600 pb-3" }
const _hoisted_3 = { class: "flex h-8 w-8 items-center justify-center rounded-full bg-gray-lp-1000 text-16px font-semibold text-black-lp-200" }
const _hoisted_4 = { class: "text-14px font-semibold text-black-lp-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoodsPackageV4 = _resolveComponent("GoodsPackageV4")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.index), 1),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("managementCustomer.savedPackage.detailTitle")), 1)
    ]),
    _createVNode(_component_GoodsPackageV4, {
      showTitle: false,
      showItemDetails: false,
      showResetButton: false,
      showSavePackageCheckbox: false,
      useDefaultDimensions: true,
      isFtz: false,
      localCurrency: _ctx.formAccountCurrencyCode,
      currencyPrefix: _ctx.currencyPrefix,
      numericLocale: _ctx.numericLocale,
      isForeign: _ctx.isForeign,
      commodity: _ctx.commodity,
      commodities: _ctx.commoditySearchResults,
      recommendedCommodities: _ctx.commodityRecommendations,
      errors: _ctx.errors,
      loading: _ctx.commodityListLoading,
      hasMore: _ctx.commodityListHasMore,
      modalSearchResults: _ctx.modalSearchResults,
      commodityCategories: _ctx.commodityCategories,
      commodityCategoryItems: _ctx.commodityCategoryItems,
      selectedCategoryCode: _ctx.selectedCategoryCode,
      modalLoading: _ctx.commodityModalLoading,
      modalLoadingCategory: _ctx.commodityModalLoadingCategory,
      modalHasMore: _ctx.commodityModalHasMore,
      pieces: _ctx.piecesData,
      volumeWeightDivisor: _ctx.volumeWeightDivisor,
      maxPieces: 15,
      "onUpdate:commodity": _ctx.onCommodityUpdate,
      "onUpdate:pieces": _ctx.onPiecesUpdate,
      onSearchCommodity: _ctx.searchCommodity,
      onLoadMoreCommodities: _ctx.loadMoreCommodities,
      onSearchCommodityModal: _ctx.searchCommodityModal,
      onLoadMoreCommodityModal: _ctx.loadMoreCommodityModal,
      onSelectCommodityCategory: _ctx.selectCommodityCategory,
      onCommodityError: _ctx.onCommodityError,
      onCommodityValidationChange: _ctx.onCommodityValidationChange,
      onPackageWeightValidationChange: _ctx.onPackageWeightValidationChange,
      onReset: _ctx.onReset
    }, null, 8, ["localCurrency", "currencyPrefix", "numericLocale", "isForeign", "commodity", "commodities", "recommendedCommodities", "errors", "loading", "hasMore", "modalSearchResults", "commodityCategories", "commodityCategoryItems", "selectedCategoryCode", "modalLoading", "modalLoadingCategory", "modalHasMore", "pieces", "volumeWeightDivisor", "onUpdate:commodity", "onUpdate:pieces", "onSearchCommodity", "onLoadMoreCommodities", "onSearchCommodityModal", "onLoadMoreCommodityModal", "onSelectCommodityCategory", "onCommodityError", "onCommodityValidationChange", "onPackageWeightValidationChange", "onReset"])
  ]))
}